import React from "react";
import { useSelector, useDispatch } from "types/store";
import * as viewReducer from "containers/View/reducer";
import { TemplateItem } from "components/View/TemplatesView";
import styles from "./style.module.css";
import templatesViewStyles from "components/View/style.module.css";
import { VIEW_TYPE } from "containers/View/reducer";
import * as chatGPTReducer from "../../containers/ChatGPT/reducer";
const TopSampleTemplates = ({ selectedTemplate, updateSelectedTemplate }) => {
    const dispatch = useDispatch();
    const topSampleTemplates = useSelector((state) => viewReducer.getTopSampleTemplates(state));
    const numberOfTemplates = useSelector((state) => viewReducer.getNumberOfTemplates(state));
    const contextSelectionPanelTab = useSelector((state) => chatGPTReducer.getContextSelectionPanelTab(state));
    const showSettings = useSelector((state) => chatGPTReducer.getShowSettings(state));
    const linkToAllTemplates = {
        description: "Choose any template to jump start your agent creation",
        name: numberOfTemplates > 1 ? `View all ${numberOfTemplates} templates` : `View 1 available template`
    };
    const showSidePanel = Boolean(contextSelectionPanelTab) || showSettings;
    return (React.createElement("div", { className: styles.topSampleTemplatesContainer },
        topSampleTemplates.map((template) => {
            return (React.createElement(TemplateItem, { hideTags: true, item: template, selectedItem: selectedTemplate, updateSelectedItem: updateSelectedTemplate, isSmall: true, key: "topSampleTemplate__" + template?.id, className: `${styles.templateItem} ${showSidePanel ? styles.templateItemWithSidePanel : ""}` }));
        }),
        numberOfTemplates > 0 && (React.createElement("div", { className: `${styles.templateItemShowAll} ${showSidePanel ? styles.templateItemWithSidePanel : ""}` },
            React.createElement("div", { className: templatesViewStyles.templateItemDetailsWrapper },
                React.createElement("div", { className: templatesViewStyles.templateItemDetailsContent, onClick: () => dispatch(viewReducer.updateType(VIEW_TYPE.AGENT_TEMPLATES)) },
                    React.createElement("div", { className: templatesViewStyles.templateIconWrapper, style: {
                            background: "#E4E8EE",
                            color: "#697586",
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "700",
                            fontSize: "24px"
                        } }, numberOfTemplates),
                    React.createElement("div", { className: templatesViewStyles.templateItemDetailsContainer },
                        React.createElement("div", { className: templatesViewStyles.templateItemTitleSection },
                            React.createElement("div", { className: templatesViewStyles.templateItemLabel }, linkToAllTemplates.name)),
                        React.createElement("div", { className: templatesViewStyles.templateItemDescription }, linkToAllTemplates.description))))))));
};
export default TopSampleTemplates;
